import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SideNavbar from './helpers/SideNavbar';
import { Button, Modal, Form } from 'react-bootstrap';
import 'react-quill/dist/quill.snow.css';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faEye, faPlus, faTrash, faExclamationTriangle, faChartBar, faLineChart, faNewspaper } from '@fortawesome/free-solid-svg-icons';
import noDataImage from "../assets/nodata.png"
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import ReactPaginate from 'react-paginate';
import { validateProfileComplete } from '../utils/profileValidation';


const ScheduleList = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
const [postIdToDelete, setPostIdToDelete] = useState(null);
const [currentPage, setCurrentPage] = useState(0);
    const postsPerPage = 6;

  const navigate = useNavigate();
  const roleId = localStorage.getItem('RoleID');
  const backPath = roleId == '4' ? '/Pagehome' : (roleId == '1' ? '/home' : '/adminhome');
  const guid = localStorage.getItem("guid");
  const UserID = localStorage.getItem("UserID");

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getallscheduledpostsbyUserID/${UserID}`);
        setPosts(response.data);
        console.log("text",response.data)
        setLoading(false);
      } catch (err) {
        console.error('Failed to fetch posts:', err.message);
        setError('Failed to fetch posts');
        setLoading(false);
      }
    };

    fetchPosts();
  }, [UserID]);

  const handleUpdateClick = (PostId) => {
    navigate(`/editschedulepost/${PostId}`);
  };

  const handleAdd = () => {
    // Check profile completion before navigating to schedule form
    if (!validateProfileComplete({ navigate })) {
      return; // Don't navigate if profile is incomplete
    }
    navigate(`/schedule`);
  };

  const handleViewPost = (PostId) => {
    navigate(`/ViewPostscheduleDet/${PostId}`);
  };

 
  const handleTime = (scheduledTimeAsPerZone) => {
    if (!scheduledTimeAsPerZone) {
      return { time: 'No time available' }; // Handle empty or undefined input
    }

    // Split the string by 'T' and take the second part (time)
    const timeString = scheduledTimeAsPerZone.split('T')[1];

    // If there's a time part, format it; otherwise, return an error message
    if (timeString) {
      const timeParts = timeString.split(':');
      const formattedTime = `${timeParts[0]}:${timeParts[1]}`; // Get hours and minutes
      return { time: formattedTime };
    } else {
      return { time: 'Invalid time' };
    }
  };

   
  const handleDeletePost = async (PostId) => {
    setPostIdToDelete(PostId);
    setShowDeleteModal(true); // Show the modal when delete button is clicked
  };
  
  const confirmDelete = async () => {
    try {
      await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/deleteschedule/${postIdToDelete}`);
      // Remove the deleted post from the state
      setPosts(posts.filter(post => post.PostId !== postIdToDelete));
      setShowDeleteModal(false); // Close the modal
    } catch (err) {
      console.error('Failed to delete post:', err.message);
      // Optionally show an error message to the user
    }
  };

 

  
  const handleClose = () => {
    setShowDeleteModal(false);
    setPostIdToDelete(null); // Reset the postIdToDelete
  };
  

  return (
    <SideNavbar>
      <div className="card shadow-sm p-3 mt-3" style={{ border: 'none', backgroundColor: '#fff' }}>
        <div className="card-header d-flex justify-content-between align-items-center" style={{ border: 'none', backgroundColor: '#fff', padding: '16px' }}>
          <div className='d-flex align-items-center'>
            <Link to={backPath}>
              <h5 className="welcome-text mb-0" style={{ fontSize: '20px', color: '#2e3192', textAlign: 'left', margin: 0 }}>
                <i class="fa fa-arrow-left" style={{marginRight:'30px'}}aria-hidden="true"></i>Schedule List
              </h5>
            </Link>
          </div>
          <div className='d-flex align-items-center' style={{ gap: '12px' }}>
          <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Create New Schedule Post</Tooltip>)}>
              <button
                onClick={() => { handleAdd() }}
                // title="Create New Schedule Post"
                style={{
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  padding: '8px',
                  borderRadius: '8px',
                  color: '#2e3192',
                  transition: 'all 0.3s ease',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '4px'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#f3f2ef';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                }}
              >
                <FontAwesomeIcon icon={faPlus} style={{ fontSize: '20px' }} />
                <span style={{ fontSize: '11px', fontWeight: '500' }}>Create</span>
              </button>
            </OverlayTrigger>
            {/* Navigation Icons */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <button
                onClick={() => navigate('/viewallpendingposts')}
                title="View Pending Posts"
                style={{
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  padding: '8px',
                  borderRadius: '8px',
                  color: '#2e3192',
                  transition: 'all 0.3s ease',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '4px'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#f3f2ef';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                }}
              >
                <FontAwesomeIcon icon={faExclamationTriangle} style={{ fontSize: '20px' }} />
                <span style={{ fontSize: '11px', fontWeight: '500' }}>Pending</span>
              </button>
              
              <button
                onClick={() => navigate('/viewallapprovedposts')}
                title="View Approved Posts"
                style={{
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  padding: '8px',
                  borderRadius: '8px',
                  color: '#2e3192',
                  transition: 'all 0.3s ease',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '4px'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#f3f2ef';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                }}
              >
                <FontAwesomeIcon icon={faChartBar} style={{ fontSize: '20px' }} />
                <span style={{ fontSize: '11px', fontWeight: '500' }}>Approved</span>
              </button>
              
              <button
                onClick={() => navigate('/viewallpostedposts')}
                title="View Published Posts"
                style={{
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  padding: '8px',
                  borderRadius: '8px',
                  color: '#2e3192',
                  transition: 'all 0.3s ease',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '4px'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#f3f2ef';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                }}
              >
                <FontAwesomeIcon icon={faNewspaper} style={{ fontSize: '20px' }} />
                <span style={{ fontSize: '11px', fontWeight: '500' }}>Published</span>
              </button>
            </div>           
            
          </div>
        </div>
        <hr />
        <div className="container mt-5">
          {loading ? (
            <div className='spinner'></div>
          ) : posts.length === 0 ? (
            <div style={{ textAlign: 'center' }}>
              <img src={noDataImage} alt="No Data" style={{ width: '50%' }} />
              <p style={{ color: '#2e3192', fontSize: '20px' }}>No posts available</p>
            </div>
          ) : (
            <div className="row">
              {/* {posts.map(post => { */}
              {posts
  .slice(currentPage * postsPerPage, (currentPage + 1) * postsPerPage)
  .map(post => {
                const {  time } = handleTime(post?.ScheduledTimeAsPerZone);
                return (
                  <div className="col-md-4" key={post.PostId}>
                    <div className="card mb-4" style={{ height: 400 }}>
                      <div className='card-body schedule-card'>
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Start Date</Tooltip>)}>
  <div><b style={{ color: "#2e3192" }}>Start Date:</b> {  post.StartDate?.split('T')[0]}</div>
  </OverlayTrigger> 
  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>End Date</Tooltip>)}>
 <div className='mt-3'><b style={{ color: "#2e3192" }}>End Date:</b> {post.EndDate?.split('T')[0]}</div>
                     </OverlayTrigger>  
                     <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Prompt</Tooltip>)}>
                      <div className='mt-3'>
                        <b style={{ color: "#2e3192" }}>Prompt:</b>{' '}
                        {(() => {
                          const candidates = [post?.Prompt, post?.Prompts, post?.prompt, post?.prompts, post?.PromptID, post?.promptId, post?.promptID];
                          const first = candidates.find(v => typeof v === 'string' && v.trim().length);
                          if (first) {
                            const raw = first.trim();
                            return raw.includes('|') ? raw.split('|').join(',') : raw;
                          }
                          return '—';
                        })()}
                      </div>
                       </OverlayTrigger>
                       <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Days</Tooltip>)}>
                        <div className='mt-3'><b style={{ color: "#2e3192" }}>Days:</b> {post.Days}</div>
                        </OverlayTrigger>
                        <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>TimeZone</Tooltip>)}>
                     <div className='mt-3'><b style={{ color: "#2e3192" }}>TimeZone:</b> {post.TimeZone}</div>
                        </OverlayTrigger>
                        {post?.ScheduledTimeAsPerZone && (
                                                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Scheduled Time</Tooltip>)}>

                  <div className="mt-3">
                    <b style={{ color: "#2e3192" }}>Scheduled Time:</b> {time}
                  </div>
                  </OverlayTrigger>
                )}                      </div>
                      <div className='card-footer text-center d-flex justify-content-between'>
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>View</Tooltip>)}>

                        <Button
                          variant="primary"
                          onClick={() => handleViewPost(post.PostId)}
                        >
                          <FontAwesomeIcon icon={faEye} className='fa-icon' />
                        </Button>
                        </OverlayTrigger>
                        
                        <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Edit</Tooltip>)}>
                        <Button
                          variant="primary"
                          onClick={() => handleUpdateClick(post.PostId)}
                        >
                          <FontAwesomeIcon icon={faEdit} className='fa-icon' />
                        </Button>
                        </OverlayTrigger>
                        
                        <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Delete</Tooltip>)}>

                        <Button
                          variant="primary"
                           onClick={() => handleDeletePost(post.PostId)}
                        >
                          <FontAwesomeIcon icon={faTrash} className='fa-icon' />
                        </Button>
                        </OverlayTrigger>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
        {posts.length > postsPerPage && (
    <ReactPaginate
      previousLabel={"Previous"}
      nextLabel={"Next"}
      pageCount={Math.ceil(posts.length / postsPerPage)}
      onPageChange={(selectedItem) => setCurrentPage(selectedItem.selected)}
      containerClassName={"pagination"}
      previousLinkClassName={"page-link"}
      nextLinkClassName={"page-link"}
      pageClassName={"page-item"}
      pageLinkClassName={"page-link"}
      activeClassName={"active"}
      disabledClassName={"disabled"}
      breakLabel={"..."}
      breakClassName={"page-item"}
      breakLinkClassName={"page-link"}
    />
 
)}

      </div>
      <Modal show={showDeleteModal} onHide={handleClose}>
  <Modal.Header closeButton>
    <Modal.Title>Confirm Delete</Modal.Title>
  </Modal.Header>
  <Modal.Body>Are you sure you want to delete this scheduled post?</Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={handleClose}>
      Cancel
    </Button>
    <Button variant="danger" onClick={confirmDelete}>
      Delete
    </Button>
  </Modal.Footer>
</Modal>

    </SideNavbar>
  );
};

export default ScheduleList;
